// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardWrapper_wrapper__ws8KJ","settings":"DashboardWrapper_settings__RUPH0"};